<template>
  <div >
    <div style="padding-bottom: 3vh">
          <div style="display: flex; height: 4.6vh;padding-left: 3vw">
            <div class="query"  @click="getEdit()" v-if="isAdmin=='admin'">编辑</div>
            <div class="query" v-if="editBtn==true" @click="save()">保存</div>
            <div class="query" v-if="editBtn==true" @click="can()">取消</div>
        </div>
    </div>

    <el-form ref="form" :model="form"   >
      <el-row  >
        <el-col :span="8">
          <el-form-item label="村域总面积(亩)" label-width="120px" style="color: #00c0ff">
            <el-input v-model="form.totalArea" :disabled="!editBtn"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="农业用地(亩)" label-width="120px">
            <el-input v-model="form.agriculturalArea" :disabled="!editBtn"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="延保土地(亩)" label-width="120px">
            <el-input v-model="form.extendWarranty" :disabled="!editBtn"></el-input>
          </el-form-item>
        </el-col>
      </el-row>

      <el-row >
        <el-col :span="8">
          <el-form-item label="镇保土地(亩)" label-width="120px">
            <el-input v-model="form.chinburgLand" disabled></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="村级流转土地(亩)" label-width="120px">
            <el-input v-model="form.roamLand" :disabled="!editBtn"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="非耕地等(亩)" label-width="120px">
            <el-input v-model="form.unplowland" :disabled="!editBtn"></el-input>
          </el-form-item>
        </el-col>
      </el-row>

      <el-row >
        <el-col :span="8">
          <el-form-item label="集中居住、减量化土地(亩)" label-width="220px">
            <el-input v-model="form.reserveArea" disabled></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="转制集体土地(亩)" label-width="120px">
            <el-input v-model="form.transferArea" disabled></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="其他(亩)" label-width="120px">
            <el-input v-model="form.otherArea" disabled></el-input>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>


  </div>
</template>

<script>
import {getCunTotal, getCunLandEdit, getLandTotal} from "@/api/Hosing";
export default {
  name: "userJurisdiction",
  props:{
    rowId:String,
    isAdmin:String,
  },
  data() {
    return {
      form: {
        nickName: "",
        userName: "", // 手机号
        etName:'', // 企业
      },
      totalList: [],
      currentPage: 1,
      pageSize: 15,
      total: 0,
      btn:0,
      editBtn:false
    };
  },

  methods: {
    getEdit(){
      this.editBtn = true;
    },
    save(){
      let data = this.form;
      getCunLandEdit(data).then((res) => {
        if (res.code ===200){
          this.$message({
            showClose: false,
            message: "修改成功",
            type: "success",
          });
          this.editBtn = false;
          this.getList();
        }

      });

    },
    can(){
      this.editBtn = false;
      this.getList();
    },
    goIndex(){
      this.$router.push("/index");
    },
    headerStyle() {
      return "background:#0F2455;color:#fff;border: 1px solid #286AE8;text-align:center";
    },
    rowStyle() {
      return "background:#0F2455;color:#fff;border: 1px solid #286AE8;text-align:center";
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.getList();
    },
    handleCurrentChange(currentPage) {
      this.currentPage = currentPage;
      this.getList();
    },
    chooseBtn(e){
      this.btn = e;
    },
    getList() {
      let data = {
        pageSize: this.pageSize,
        pageNum: this.currentPage,
        manageId: this.rowId,
      };
      getCunTotal(data).then((res) => {
        this.form = res.data;
        this.total = res.total;
      });
    },
    getRentList() {
      let data = {
        pageSize: this.pageSize,
        pageNum: this.currentPage,
        manageType: 1,
      };
      getCunTotal(data).then((res) => {
        this.totalList = res.data;
        this.total = res.total;
      });
    },

  },
  mounted() {
     this.getList();
  },
};
</script>

<style lang="scss" scoped>
.container::v-deep {
  margin-top: 2vh;
  width: 100%;
  position: relative;
  .left-title {
    position: absolute;
    left: 0;
    top: 0;
    background: url(@/assets/images/titleBg.png);
    background-size: 100% 100%;
    width: 11.1vw;
    height: 5.5vh;
    color: #fff;
    font-size: calc(100vw * 20 / 1920);
    text-align: center;
    line-height: 5.5vh;
    margin-right: 4vw;
  }
  .right-container {
    width: 81vw;
    position: absolute;
    left: 3vw;
    right: 0;
    margin: 0 auto;

    .right-top {

      width: 100%;
      display: flex;
      justify-content: space-between;
      align-items: center;
      .el-form-item {
        display: flex;
        align-items: center;
        height: 4.6vh;

        .item.el-input__inner {
          width: 100%;
          height: 4.6vh;
          font-size: calc(100vw * 16 / 1920);
          box-shadow: inset 0rem 0rem 0.43rem 0.17rem rgba(44, 98, 230, 0.28);
          border-radius: 6px;
          border: 0.02rem solid #286ae8;
          background: none;
          color: #fff;
          &::placeholder {
            color: #fff;
          }
        }
        .el-form-item__label {
          width: 6.5vw;
          text-align: left;
          color: #f0c78a !important;
          font-size: calc(100vw * 16 / 1920);

        }
      }
      .query,
      .reset {
        width: 10vw;
        height: 100%;
        background: url(@/assets/images/updown.png);
        background-size: 100% 100%;
        color: #02b5ff;
        font-size: calc(100vw * 16 / 1920);
        line-height: 4.6vh;
        text-align: center;
        cursor: pointer;
      }
      .query {
        margin-right: 3vw;
      }
    }
  }
}
::v-deep .el-form {
  width: 80vw;
  //padding-left: 10vw;
  box-sizing: border-box;
}
::v-deep .el-table {
  width: 99.9%;
  margin-bottom: 2.5vh;
  font-size: calc(100vw * 16 / 1920);
}
::v-deep .el-table__body {
  font-size: calc(100vw * 14 / 1920);
}
::v-deep .el-table__row {
  height: 4vh;
}
.el-table--border::after,
.el-table--group::after,
.el-table::before {
  display: none;
}
::v-deep .el-pagination {
  width: 100%;
  display: flex;
  justify-content: flex-end;
  margin-bottom: 1vh;
}
::v-deep .el-pagination .el-select .el-input .el-input__inner,
::v-deep .el-pagination .btn-next,
::v-deep .el-pagination .btn-prev,
::v-deep .el-pager li,
::v-deep .el-pager li.btn-quicknext,
::v-deep .el-pager li.btn-quickprev,
::v-deep .el-pagination__total {
  //background: #0f2455;
  border-radius: 6px;
  border: 1px solid #286AE8;
  box-shadow: inset 0px 0px 20px 21px rgba(15,53,116,0.6);
  color: #fff;
  text-align: center;
}
::v-deep .el-pager li,
::v-deep .el-pagination .btn-next,
::v-deep .el-pagination .btn-prev {
  margin-right: 0.5vw;
}
::v-deep .el-pagination__total {
  margin-right: 0;
  padding: 0 0.8vw;
  box-sizing: border-box;
}
::v-deep .el-form-item__content {
  height: 4.6vh;
}
::v-deep .el-pager li.active {
  color: #409EFF;
}

.lightBtn{
  background: url(@/assets/use/btn3.png) !important;
  background-size: 100% 100% !important;
  color: #2EE6FE !important;
  width: 12vw;
  height: 100%;
  background-size: 100% 100%;
  font-size: calc(100vw * 16 / 1920);
  line-height: 4.6vh;
  text-align: center;
  cursor: pointer;

}
.btn{
  background: url(@/assets/images/updown.png);
  background-size: 100% 100%;
  color: #02b5ff;
  width: 12vw;
  height: 100%;
  font-size: calc(100vw * 16 / 1920);
  line-height: 4.6vh;
  text-align: center;
  cursor: pointer;

}



::v-deep .el-form-item__label {
    color: #00c0ff;

  }

.query,
.reset {
  width: 10vw;
  height: 100%;
  background: url(@/assets/images/updown.png);
  background-size: 100% 100%;
  color: #02b5ff;
  font-size: calc(100vw * 16 / 1920);
  line-height: 4.6vh;
  text-align: center;
  cursor: pointer;
}
.query {
  margin-right: 3vw;
}

::v-deep .el-input.is-disabled .el-input__inner {
  color: rebeccapurple;
}

</style>
